export default "__VITE_ASSET__B5Id6TRU__"